var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2.14375C2 1.51207 2.48653 1 3.0867 1H16.8515C17.4517 1 17.9382 1.51207 17.9382 2.14375C17.9382 2.77542 17.4517 3.2875 16.8515 3.2875H3.0867C2.48653 3.2875 2 2.77542 2 2.14375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7.09999C2 6.46831 2.48653 5.95624 3.0867 5.95624H11.7803C12.3804 5.95624 12.867 6.46831 12.867 7.09999C12.867 7.73166 12.3804 8.24374 11.7803 8.24374H3.0867C2.48653 8.24374 2 7.73166 2 7.09999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12.4375C2 11.8058 2.48653 11.2937 3.0867 11.2937H8.15795C8.75811 11.2937 9.24464 11.8058 9.24464 12.4375C9.24464 13.0692 8.75811 13.5812 8.15795 13.5812H3.0867C2.48653 13.5812 2 13.0692 2 12.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9017 17.3989C16.3016 17.4018 15.8128 16.8921 15.81 16.2604L15.7698 7.11055C15.7671 6.47888 16.2513 5.96445 16.8515 5.96153C17.4517 5.95861 17.9404 6.46831 17.9432 7.09997L17.9834 16.2499C17.9862 16.8815 17.5019 17.396 16.9017 17.3989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3143 12.9995C12.7387 12.5529 13.4267 12.5529 13.8511 12.9995L17.6972 17.0475C18.1215 17.4942 18.1215 18.2183 17.6972 18.665C17.2728 19.1117 16.5847 19.1117 16.1603 18.665L12.3143 14.617C11.8899 14.1704 11.8899 13.4462 12.3143 12.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6817 12.9995C21.2573 12.5529 20.5693 12.5529 20.1449 12.9995L16.2988 17.0475C15.8745 17.4942 15.8745 18.2183 16.2988 18.665C16.7232 19.1117 17.4113 19.1117 17.8357 18.665L21.6817 14.617C22.1061 14.1704 22.1061 13.4462 21.6817 12.9995Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2085",
    x: 0,
    y: 0,
    width: 24,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2085",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.ea4e434f7659f3bc536fe06b8c5c0487.svg";
export { ForwardRef as ReactComponent };